import { render, staticRenderFns } from "./ControllingDetails.vue?vue&type=template&id=23c6d266&"
import script from "./ControllingDetails.vue?vue&type=script&lang=js&"
export * from "./ControllingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports